import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";

const { Option } = Select;

function AttributeFilterModel(props) {
  const [submit, setSubmit] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.visible) {
      props.filterBy?.name &&
        form.setFields([{ name: "name", value: props.filterBy?.name }]);
      props.filterBy?.valueType &&
        form.setFields([
          { name: "valueType", value: props.filterBy?.valueType },
        ]);
      props.filterBy?.status &&
        form.setFields([{ name: "status", value: props.filterBy?.status }]);
    }
  }, [props.visible]);

  function handleCancel() {
    setSubmit(false);
    props.handleCancel();
    form.resetFields();
  }

  const onFinish = (values) => {
    setSubmit(true);
    props.handleOk(values);
    handleCancel();
  };

  return (
    <Modal
      title="Filter Attributes"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="organizationFilter"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        form={form}
      >
        <Form.Item label="Attribute name" name="name">
          <Input placeholder="Attribute name" />
        </Form.Item>

        <Form.Item label="Value type" name="valueType">
          <Select placeholder="Select type">
            <Option key={"text"} value={"text"}>
              Text
            </Option>
            <Option key={"number"} value={"number"}>
              Number
            </Option>
            <Option key={"date"} value={"date"}>
              Date
            </Option>
          </Select>
        </Form.Item>

        <Form.Item label="Status" name="status">
          <Select placeholder="Select status">
            <Option key={"active"} value={"Active"}>
              Active
            </Option>
            <Option key={"disabled"} value={"disabled"}>
              Disabled
            </Option>
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button
              className="w-28"
              type="primary"
              htmlType={submit && "submit"}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Filter"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AttributeFilterModel;
